export default __webpack_public_path__ + "static/media/xlsFileIcon.bb1e25c4.svg";